import { baseApi } from "../baseApi";

export const companyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompany: builder.query({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_company_list`,
      })
    }),
    getCompayList: builder.query({
      query: () => ({
        url: `/api/method/frappe.desk.reportview.get/Company`,
        params: {
          doctype: 'Company',
          fields: '["company_name", "country","parent_company"]',
          view: 'List',
        },
      }),
    }),
    getCurrencyList: builder.query({
      query: () => ({
        url: `/api/resource/Currency`,
        params:{"limit_page_length":1000000}
      }),
    }),
    getCountryList: builder.query({
      query: () => ({
        url: `/api/resource/Country`,
        params:{"limit_page_length":1000000}
      }),
    }),
    getLetterHeadList: builder.query({
      query: () => ({
        url: `/api/resource/Letter Head`,
        params:{"limit_page_length":1000000}
      }),
    }),
    getHolidayList: builder.query({
      query: () => ({
        url: `/api/resource/Holiday List`,
        params:{"limit_page_length":1000000}
      }),
    }),
    getParentCompanyList: builder.query({
      query: (params) => ({
        url: `/api/method/frappe.desk.reportview.get`,
        params
      }),
    }),
    getHrPayrollList: builder.query({
      query: (params) => ({
        url: `/api/resource/Account`,
        params
      }),
    }),
    getSelectedCompany: builder.query({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_selected_company`,
      })
    }),
    postCreateCompany: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Company`,
        method:'post',
        body:data
      })
    }),
    postUpdateCompany: builder.mutation({
      query: ({ company_name, ...payload }) => ({
        url: `/api/resource/Company/${company_name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    postSetCompany: builder.mutation({
      query: ({name}) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.set_selected_company?company=${name}`,
        method:'post'
      })
    }),
  }),
});

export const { useGetCompanyQuery,useGetSelectedCompanyQuery,usePostSetCompanyMutation,useGetCompayListQuery,useGetCurrencyListQuery,useGetCountryListQuery,useGetLetterHeadListQuery,useGetHolidayListQuery,useGetHrPayrollListQuery,usePostCreateCompanyMutation,usePostUpdateCompanyMutation,useGetParentCompanyListQuery } = companyApi;
